export const styleTab = {
  padding: '10px 10px',
  display: 'inline-flex',
  cursor: 'pointer',
  color: '#231F20',
  textAlign: 'center',
  fontSize: '18px',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: '600'
};

export const styleActiveTab = {
  ...styleTab,
  background: 'inherit',
  borderBottom: 'solid #04AAEB 2px'
};
